import {Routes} from '@angular/router';
import {
  BaseInfoComponentConfig,
  BaseInfoSectionComponent
} from './common/base-info-section/base-info-section.component';
import {
  ApplicantDataComponentConfig,
  ApplicantDataSectionComponent
} from './common/applicant-data-section/applicant-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from './common/attachments-data-section/attachments-data-section.component';
import {
  TaxObjectDataComponentConfig,
  TaxObjectDataSectionComponent
} from './common/tax-object-data-section/tax-object-data-section.component';
import {
  AgreementsDataComponentConfig,
  AgreementsDataSectionComponent
} from './common/agreements-data-section/agreements-data-section.component';
import {SessionService} from '../../../services/ssession.service';

export const desktopStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot opodatkowania',
  'Zgody',
  'Załączniki'
];

export const mobileStages: string[] = [
  'Informacje podstawowe',
  'Dane identyfikacyjne',
  'Przedmiot opodatkowania',
  'Zgody',
  'Załączniki'
];

export const stages = SessionService.GetUISettings()?.mobileEmbed ? mobileStages : desktopStages;

export const baseInfoSectionConfig: BaseInfoComponentConfig = {
  stages,
  successUrl: 'dane-identyfikacyjne'
};

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages,
  successUrl: '../przedmiot-opodatkowania',
  cancelUrl: '../informacje-podstawowe'
};

export const taxObjectDataSectionConfig: TaxObjectDataComponentConfig = {
  stages,
  customTitles: {
    cardTitle: 'Dodanie nieruchomości',
    cardTitle2: 'Edycja nieruchomości',
    addBtnTitle: 'Dodaj nieruchomość',
    addBtn2Title: 'Dodaj kolejną nieruchomość',
    noDataInfo: 'Brak dodanych nieruchomości!'
  },
  successUrl: '../zgody',
  cancelUrl: '../dane-identyfikacyjne',
  removeIsPartOfNatureReserveControl: true,
  removeIsTaxExemptControl: true,
  addPropertyTypeControl: true,
  addAreaTypeControl: true
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../przedmiot-opodatkowania',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const propertyTaxIn1DesktopRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-opodatkowania',
    component: TaxObjectDataSectionComponent,
    data: taxObjectDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const propertyTaxIn1MobileRoutes: Routes = [
  {
    path: 'informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/informacje-podstawowe',
    component: BaseInfoSectionComponent,
    data: baseInfoSectionConfig
  },
  {
    path: ':appId/dane-identyfikacyjne',
    component: ApplicantDataSectionComponent,
    data: applicantDataSectionConfig
  },
  {
    path: ':appId/przedmiot-opodatkowania',
    component: TaxObjectDataSectionComponent,
    data: taxObjectDataSectionConfig
  },
  {
    path: ':appId/zgody',
    component: AgreementsDataSectionComponent,
    data: {
      ...agreementsDataSectionConfig,
      removeRegulationsControl: true
    }
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  {path: '', redirectTo: 'informacje-podstawowe', pathMatch: 'prefix'}
];

export const propertyTaxIn1Routes: Routes = SessionService.GetUISettings()?.mobileEmbed ? propertyTaxIn1MobileRoutes : propertyTaxIn1DesktopRoutes;
